import { render, staticRenderFns } from "./BudgetResearch.vue?vue&type=template&id=2dda9ab6&scoped=true&"
import script from "./BudgetResearch.vue?vue&type=script&lang=js&"
export * from "./BudgetResearch.vue?vue&type=script&lang=js&"
import style0 from "./BudgetResearch.vue?vue&type=style&index=0&id=2dda9ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda9ab6",
  null
  
)

export default component.exports